import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCrossBox = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 12 12",
	width: "1em",
	height: "1em",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M3 1.5h6a1.5 1.5 0 0 1 1.5 1.5v6a1.5 1.5 0 0 1-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5v-6a1.5 1.5 0 0 1 1.5-1.5zM3 2.5a0.5 0.5 0 0 0-0.5 0.5v6a0.5 0.5 0 0 0 0.5 0.5h6a0.5 0.5 0 0 0 0.5-0.5v-6a0.5 0.5 0 0 0-0.5-0.5z"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 5.5,
			y: 3.5,
			width: 1,
			height: 5,
			rx: .5
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 3.5,
			y: 5.5,
			width: 5,
			height: 1,
			rx: .5
		})
	]
});
const ForwardRef = forwardRef(SvgCrossBox);
export default ForwardRef;
